import PropTypes from 'prop-types';
import { Switch, Checkbox, Slider } from './ToggleBtn.style';

const ToggleBtn = ({ value, onChange, name }) => (
  <Switch data-testid="switch">
    <Checkbox
      checked={value}
      onChange={onChange}
      type="checkbox"
      data-testid="togglebtn"
      name={name}
    />
    <Slider data-testid="slider" />
  </Switch>
);

export default ToggleBtn;

ToggleBtn.propTypes = {
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
};

ToggleBtn.defaultProps = {
  name: '',
};
